import { translate } from '@/composables/useLocale'

export interface ReauthContext {
  action: string
  password_required: boolean
  email_code_required: boolean
  mfa_required: boolean
}

let handler: ((context: ReauthContext) => Promise<string>) | null = null

export function registerReauthHandler(value: typeof handler) {
  handler = value
}

export function requestReauth(context: ReauthContext): Promise<string> {
  const locale = localStorage.getItem('tikflow_locale') || 'zh-CN'
  return handler ? handler(context) : Promise.reject(new Error(translate(locale, 'reauth.not_ready')))
}
